import { useLayoutEffect } from 'react';
import { SmallHeightDivider } from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { Container } from './styles/FrequentQuestionsStyles';
import { useQuery } from 'react-query';
import CenterLoading from '../../components/CenterLoading/CenterLoading';
import { getFrequentQuestions } from '../../api/FrequentQuestions';
import Collapsable from '../../components/Collapsable/Collapsable';

function FrequentQuestions() {

  const dispatch = useDispatch();
  const { data: frequentQuestionsData, isLoading: frequentQuestionsDataLoading } = useQuery(['frequentQuestionsData'], () => getFrequentQuestions());

  useLayoutEffect(() => {
    //UPDATE APP HEADER SUBTITLE
    dispatch(UpdateAppSubHeaderTitle("Preguntas frecuentes"));
  }, []);

  if (frequentQuestionsDataLoading) return <CenterLoading />;
  return (
    <Container>
      <SmallHeightDivider />
      {
        frequentQuestionsData.vui?.map((question) => (
          <div>
            <Collapsable
              title={question.question}
              content={question.answer}
            />
            <SmallHeightDivider />
          </div>
        ))
      }
    </Container>
  );
}

export default FrequentQuestions;
